import React from 'react';

/**
 * BuilderSidebar - Simplified sidebar for START and PROMPT screens
 * Projects list is now handled by BuilderProjectsGrid with folder support
 */
function BuilderSidebar({ onNewChat, onBackToProjects }) {
  return (
    <div className="builder-sidebar">
      {/* Create New Section */}
      <div className="sidebar-section create-section">
        <button className="sidebar-create-btn" onClick={onNewChat}>
          <div className="create-icon">
            <PlusIcon />
          </div>
          <span>Create New</span>
        </button>
      </div>

      {/* Back to Projects link */}
      {onBackToProjects && (
        <div className="sidebar-section">
          <button className="sidebar-back-btn" onClick={onBackToProjects}>
            <BackIcon />
            <span>Back to Projects</span>
          </button>
        </div>
      )}
    </div>
  );
}

function PlusIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 3V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function BackIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  );
}

export default BuilderSidebar;
